// Cashback Icon component - C with $ inside and arrow
import cashbackIconImage from '../assets/images/CashbackIcon.png';

const CashbackIcon = ({ size = 24, className = '' }: { size?: number; className?: string }) => {
  return (
    <img 
      src={cashbackIconImage} 
      alt="Cashback Icon" 
      width={size}
      height={size}
      className={className}
      style={{ display: 'inline-block' }}
    />
  );
};

export default CashbackIcon;

